import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationsCountsKey, errorMessage } from '@features/applications';
import { messagesKey, sendEnterpriseMessageRoute, sendMessageRoute } from '@features/messaging';
import axiosInstance from '@server/axiosInstance';

type useSenEnterpriseMessageProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useSenEnterpriseMessage = ({
  setErrorText = () => { },
}: useSenEnterpriseMessageProps) => {
  const client = useQueryClient();

  const { mutate: sendMessage, isLoading: isSendingMessage } = useMutation({
    mutationFn: (variables: {
      message: string;
      thread_id?: number | undefined;
      application_id?: number;
      company_id?: string;
      message_doc?: File | null;
    }) => {
      return axiosInstance
        .post(sendEnterpriseMessageRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([messagesKey]);
        client.invalidateQueries([applicationsCountsKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    sendMessage,
    isSendingMessage,
  };
};
